import angular from "angular";

import { SessionService, UserSettingsService } from "../../services";
import { AjaxNg1 } from "../../ajax";
import { UserSession } from "@salaxy/core";

/**
 * The controller is used in creating embedded UI:s: When this NG1 based SPA is run in an iframe
 * and the parent sends token, session and settings as window messages.
 */
export class EmbeddedUiController implements angular.IController {

  /**
   * For NG-dependency injection
   * @ignore
   */
  public static $inject = ["SessionService", "$timeout", "AjaxNg1", "$location", "UserSettingsService"];

  private _isLoading = true;

  /**
   * Creates a new EmbeddedUiController
   * @ignore
   */
  constructor(private sessionService: SessionService, private $timeout: angular.ITimeoutService, private ajax: AjaxNg1, private $location: angular.ILocationService, private userSettingsService: UserSettingsService) { }

  /**
   * Implement IController
   */
  public $onInit = () => {
    this.startListening();
  };

  /**
   * If true, the layout should show a full-page loader instead of normal pages.
   * Controllers in normal pages should be destoyed (e.g. using ng-if) so that this can also
   * be used in reloading the AngularJS user interface without full Browser reload.
   */
  public get showFullPageLoader(): boolean {
    return this._isLoading || this.sessionService.isLoading;
  }

  /**
   * Gets the user-specific setting (service), stored in the local storage.
   */
  public get userSettings() {
    return this.userSettingsService;
  }

  private firstMessageTimeout: number |undefined;
  private parentOrigin: string | undefined;

  /**
   * Starts listening for the session change events from the parent frame.
   */
  public startListening(): void {
      if (window.parent === window) {
        throw new Error("This is the parent window.");
      }
      window.addEventListener("message", this.onMessageReceived);
      this.firstMessageTimeout = window.setTimeout(() => {
        throw new Error("Timeout while waiting for session.");
      }, 4000);
      // This does not work in refresh => Can we determine the parent referrer in some other way?
      // this.parentOrigin = document.referrer.replace(/\/[^/]*$/, "");
      this.parentOrigin = "*";
      window.parent.postMessage({ action: "sxy-iframe-ready" }, this.parentOrigin);
  }

  private onMessageReceived = (ev: MessageEvent<SessionChangeEventData>) => {
    if (ev.data.action === "sxy-iframe-change-session") {
      if (this.firstMessageTimeout) {
        clearTimeout(this.firstMessageTimeout);
        this.firstMessageTimeout = undefined;
      }
      if (ev.origin !== this.parentOrigin && this.parentOrigin !== "*") {
        console.error(`Invalid origin ${ev.origin} vs ${this.parentOrigin}.`);
        return;
      }
      const data: SessionChangeEventData = ev.data;
      if (!data.session || !data.token) {
        throw new Error("Session or token not defined in sxy-session-response event.");
      }
      if ( this.sessionService.session?.currentAccount?.id !== data.session.currentAccount.id || this.sessionService.getCurrentToken() !== data.token ) {
        this.ajax.useCookie = false;
        this.ajax.setCurrentToken(data.token);
        // Set the isLoading flag to true to show the loader even if _isLoading will be false for the short time period before sessionService loads the en/sv language file.
        this.sessionService.isLoading = true;
        this.sessionService.setSession(data.session);
      }
      if (data.route) {
        this.$location.url(data.route);
      }
      this._isLoading = false;
      this.$timeout();
    } else {
      // throw new Error(`Invalid action ${ev.data.action}.`);
    }
  };

}

/**
 * Structure of Session event as passed from Vue-based new UI to AngularJS-based old embedded UI (NG1).
 */
type SessionChangeEventData = {

  /** Identifies the event. */
  action: "sxy-iframe-change-session";

  /** User session data. */
  session: UserSession;

  /** Token for the new session. */
  token: string;

  /** Route to which the application should go to. */
  route: string;

}
